import { lazy } from 'react';

const BotelDeepDiveSection = lazy(() => import('../BotelDeepDiveSection'));

const BotelDeepDiveSectionLazy = () => {
  return <BotelDeepDiveSection />;
};

export default BotelDeepDiveSectionLazy; 